import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PickImage, UploadImage } from '../../components/common/Camera';
import { InstallationAction, ErrorCodeAction, ProductAction } from '../../actions';
import { FileAddList } from '../../components/common/FileAddList';
import { FileUpload, FileItem } from '../../components/common/FileUpload';
import { Translate as t } from '../../config/Translate';

// 해당 타입의 첨부가 없을 때: 편집 모드면 동일 너비·가운데 정렬 샘플 이미지,
// 요약(isSummary) 모드면 "Not exist." 표시. 첨부가 있으면 아무것도 렌더하지 않음.
const SampleImageOrEmpty = ({ attachments, type, src, isSummary }) => {
	if ((attachments ?? []).filter(item => type == item.type).length != 0) return null;
	if (isSummary) return <i className="p-2">Not exist.</i>;
	return (
		<div className="text-center my-2">
			<img src={src} style={{ width: '200px', height: 'auto', maxWidth: '100%' }} />
		</div>
	);
};

const InstallationStep4 = ({ info, Update, isSummary = false, Attachment, gostep }) => {
	const [installation, setInstallation] = useState(info);
	// BUG-236: 첨부/화질 항목이 없는 설치건은 해당 필드가 undefined 라 filter/map 에서 크래시(흰 화면)
	const attachments = installation?.attachments ?? [];
	const imgQuality = installation?.imgQuality ?? [];
	const [pano, setPano] = useState(imgQuality.filter(x => x.type == "pano"));
	const [ct, setCt] = useState(imgQuality.filter(x => x.type == "ct"));
	const [ceph, setCepth] = useState(imgQuality.filter(x => x.type == "ceph"));

	useEffect(() => {
		setInstallation(info);
	}, [info]);

	// 현재 입력(화질 항목)과 목표 단계를 함께 저장. '다음'·'이전'·상단 이동이 같이 쓴다.
	const saveStep = (targetStep) => {
		let img = pano.concat(ct);
		img = img.concat(ceph);
		Update(installation._id, {
			installationStep: targetStep,
			imgQuality: img
		});
	};

	const Prev = () => {
		saveStep(4);
	};

	const validNext = (targetStep = 6) => saveStep(targetStep);

	// 상단 배지·◀▶ 이동: 이 단계는 검증이 없고 첨부는 올리는 즉시 저장되므로 목표 단계와 화질 항목을 저장한다.
	useEffect(() => {
		if (gostep && gostep.curStep == 5) {
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	const setNewFile = (file, fileType) => {
		Attachment(installation._id, "ADD", {
			...installation,
			name: file.original,
			path: file.s3path,
			attachmentType: fileType
		});
	};

	const delFile = (c) => {
		Attachment(installation._id, "DEL", {
			...installation,
			delAttachid: c._id
		});
	};

	return (
		<>
			<div className={isSummary ? "pb-1" : "section"}>
				{!isSummary &&
					<>
						<div className="section-title">{t('product.label.imageQuality')}</div>
						<blockquote className="blockquote">
							<p className="mb-0">{t('product.message.info.imageQualityComment')}</p>
						</blockquote>
					</>
				}
				<div className={isSummary ? "" : "card mb-2"}>
					<div className={isSummary ? "section-title bdB2" : "card-header"}>{t('product.type.panoramic')}</div>
					<SampleImageOrEmpty attachments={attachments} type="pano" src="/assets/img/panoramic.jfif" isSummary={isSummary} />
					<ul className="mb-0">
						{attachments.map((p, idx) =>
							p.type == "pano" &&
							<div>
								<FileItem fileInfo={{ ...p, original: p.name, s3path: p.path }} callback={(p) => delFile(p)} key={idx} />
							</div>
						)}
					</ul>
					{!isSummary &&
						<div className="card-footer">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'pano')} />
						</div>
					}
				</div>
				<div className={isSummary ? "" : "card mb-2"}>
					<div className={isSummary ? "section-title bdB2" : "card-header"}>{t('product.type.cbct')}</div>
					<SampleImageOrEmpty attachments={attachments} type="ct" src="/assets/img/cbct.jfif" isSummary={isSummary} />
					<ul className="mb-0">
						{attachments.map((x, idx) =>
							x.type == "ct" &&
							<div>
								<FileItem fileInfo={{ ...x, original: x.name, s3path: x.path }} callback={(x) => delFile(x)} key={idx} />
							</div>
						)}
					</ul>
					{!isSummary &&
						<div className="card-footer">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'ct')} />
						</div>
					}
				</div>
				<div className={isSummary ? "" : "card mb-2"}>
					<div className={isSummary ? "section-title bdB2" : "card-header"}>{t('product.type.cephalometric')}</div>
					<SampleImageOrEmpty attachments={attachments} type="ceph" src="/assets/img/cephalometric.jfif" isSummary={isSummary} />
					<ul className="mb-0">
						{attachments.map((c, idx) =>
							c.type == "ceph" &&
							<div>
								<FileItem fileInfo={{ ...c, original: c.name, s3path: c.path }} callback={(c) => delFile(c)} key={idx} />
							</div>
						)}
					</ul>
					{!isSummary &&
						<div className="card-footer">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'ceph')} />
						</div>
					}
				</div>
			</div>
			{!isSummary && <div className="section mt-1 mb-2">
				<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
				<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
			</div>}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	Attachment: (_id, type, data) => dispatch(InstallationAction.Attachment(_id, type, data)),
});

export default connect(null, mapDispatch)(InstallationStep4);